import ApplicationResource from './ApplicationResource';
export default class AdminMediaResource extends ApplicationResource {
    constructor() {
        super(...arguments);
        this.id = '';
        this.name = '';
        this.size = '';
        this.type = {};
    }
    pk() {
        return this.id;
    }
    static createShape() {
        const options = AdminMediaResource.getEndpointExtra();
        return {
            type: 'mutate',
            schema: this,
            options,
            getFetchKey: (params) => {
                return 'POST ' + AdminMediaResource.listUrl(params);
            },
            fetch: (params, body) => {
                return AdminMediaResource.fetch(AdminMediaResource.listUrl(params), { method: "post", body: body });
            },
        };
    }
}
AdminMediaResource.resource = '/admin/media';
//# sourceMappingURL=AdminMediaResource.js.map